// extracted by mini-css-extract-plugin
module.exports = {"background":"background__NPkZA","wrapper":"wrapper__2wH_X","main":"main__D2u2i"};